import { Field, ReportSelect } from './ReportControls'
import { ManpowerView } from './ManpowerReport'
import { useMonthRange } from './useMonthRange'

/**
 * docs/product/reports.md's monthly manpower report: the two-week report's
 * figures for each day of a calendar month, with the month's totals on top.
 */
export default function MonthlyManpowerReport() {
  const range = useMonthRange()
  return (
    <ManpowerView
      range={range}
      rangeFields={
        <Field label="Month">
          <ReportSelect value={range.month} onChange={(event) => range.setMonth(event.target.value)}>
            {range.choices.map((choice) => (
              <option key={choice.value} value={choice.value}>
                {choice.label}
              </option>
            ))}
          </ReportSelect>
        </Field>
      }
      regionLabel="Monthly manpower"
      title="Monthly Manpower Report"
      fileStem="monthly-manpower"
      emptyText="No manpower for this month. Choose another month or clear a filter."
    />
  )
}
